import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useConfig } from '@xingternal/hops';
import { Hero } from '@xingternal/typography';
import {
  IconJobs,
  IconContacts,
  IconNews,
  IconEvents,
} from '@xingternal/icons';

import {
  Container,
  ContentContainer,
  Text,
  Feature,
  IconContainer,
} from './KeyFeaturesSection.style';

const features = [
  {
    icon: IconJobs,
    translationId: 'JOBS_LANDING_LO_MARKETING_SEC_ONE_TEXT_ONE',
    link: '/jobs',
  },
  {
    icon: IconContacts,
    translationId: 'JOBS_LANDING_LO_MARKETING_SEC_ONE_TEXT_TWO',
    link: '/people',
  },
  {
    icon: IconEvents,
    translationId: 'JOBS_LANDING_LO_MARKETING_SEC_ONE_TEXT_THREE',
    href: 'https://bewerbung.com/',
  },
  {
    icon: IconNews,
    translationId: 'WELCOME_STARTPAGE_KEY_FEATURES_NEWS',
    link: '/news',
  },
];

const KeyFeaturesSection = () => {
  const { externalUrl } = useConfig();
  return (
    <Container>
      <Hero size="small" sizeConfined="medium" forwardedAs="h2">
        <FormattedMessage id="WELCOME_STARTPAGE_MAIN_TITLE_REG_7371_03" />
      </Hero>
      <ContentContainer>
        {features.map(({ icon: Icon, translationId, link, href }) => (
          <FormattedMessage id={translationId} key={translationId}>
            {text => (
              <Feature href={href || externalUrl + link} title={text}>
                <IconContainer>
                  <Icon aria-hidden />
                </IconContainer>
                <Text forwardedAs="span" size="xlarge">
                  {text}
                </Text>
              </Feature>
            )}
          </FormattedMessage>
        ))}
      </ContentContainer>
    </Container>
  );
};
export default KeyFeaturesSection;
